import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { toast } from "react-toastify";
import { postApiFormData } from "../../helpers/AxiosInstance";
import { usePDFPrintHook } from "@careinfo/layout";
import { useNavigate } from "react-router-dom";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../customHooks/useGetHook";
import usePostHook from "../../customHooks/usePostHook";
const CreateDebitNoteComponent = loadable(
  () => import("../../components/DebitNote/CreateDebitNote")
);

const CreateDebitNote = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const { downloadPrint, isPrintLoading } = usePDFPrintHook();
  const [openPrintPopup, setOpenPrintPopup] = useState(false);
  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const { refetch: numbSeriresRefetch } = useGetHook({
    queryKey: ["number-serires-journal-entry"],
    url: APIS.NUMBER_SERIRES,
    params: {
      type: "Debit Note",
    },
  });
  const { refetch: entryNoRefetch } = useGetHook({
    queryKey: ["journal-entry"],
    url: APIS.JOURNAL_ENTRY,
    params: {
      type: "Debit Note",
      limit: 1,
      offset: 0,
    },
  });

  const handleCreate = async (values: any, isDraft: any, setError: any) => {
    setIsLoading(true);
    const url = APIS.JOURNAL_ENTRY;
    const formData = new FormData();
    formData.append("voucher_date", values?.voucher_date ?? null);
    formData.append("reference_number", values?.reference_number ?? "");
    values?.reference_date
      ? formData.append("reference_date", values?.reference_date)
      : null;
    formData.append("number_series", values?.number_series);
    formData.append("entry_number", values?.entry_number);
    isDraft
      ? formData.append("status", "Draft")
      : formData.append("status", "Success");
    formData.append("type", "Debit Note");
    if (values?.journal_account) {
      formData.append(
        "journal_account",
        JSON.stringify(values.journal_account)
      );
    }
    if (values?.attachment?.[0] && typeof values?.attachment !== "string") {
      formData.append("attachment", values?.attachment?.[0]);
    }
    values?.narration ? formData.append("narration", values?.narration) : null;
    try {
      const res = await postApiFormData({ url, formData, setError });
      if (res?.status === 201) {
        queryClient.invalidateQueries({
          queryKey: ["debit-note"],
          refetchType: "active",
        });
        if (!isDraft) {
          setSelectedOrder(res?.data?.id);
          setOpenPrintPopup(true);
        } else {
          navigate("/accounting/debit-note");
        }
        toast.success("Create Successfully");
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };
  const handlePrint = async () => {
    const url = APIS.BILL_PRINT;
    let formData = {
      ids: [selectedOrder],
      type: "Debit Note",
    };

    try {
      const res = await downloadPrint(url, formData);
    } catch (err) {
      console.error(err);
    }
  };
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["ledger-account"],
    navigateURL: "",
  });

  const handleCreateAccount = async (
    values: any,
    setOpenAccountPopup: any,
    setError: any
  ) => {
    const url = APIS.COA;
    const formData = {
      ...values,

      is_group: false,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 201) {
        setOpenAccountPopup(false);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      <div className={tw`grid grid-cols-2 `}>
        <h1 className={tw`font-semibold text-xl leading-10`}>
          Create Debit Note
        </h1>
      </div>

      <CreateDebitNoteComponent
        handleCreate={handleCreate}
        isLoading={isLoading}
        entryNoRefetch={entryNoRefetch}
        numbSeriresRefetch={numbSeriresRefetch}
        openPrintPopup={openPrintPopup}
        setOpenPrintPopup={setOpenPrintPopup}
        handlePrint={handlePrint}
        handleCreateAccount={handleCreateAccount}
        isPostLoading={isPostLoading}
        isPrintLoading={isPrintLoading}
      />
    </div>
  );
};

export default CreateDebitNote;
